import React, { useState, useEffect } from 'react';
import { Building2, Users, ChevronDown, ChevronRight, User, Briefcase, Home, TrendingUp, Share2 } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

export default function CompanyStructureWidget() {
  const navigate = useNavigate();
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Summary data for widget
    setEntities({
      companies: 11,
      discretionaryTrusts: 5,
      unitTrusts: 3,
      smsf: 1,
      individuals: 2,
    });
    setLoading(false);
  }, []);

  return (
    <Card className="h-full" data-testid="company-structure-widget">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-semibold flex items-center gap-2">
            <Share2 className="h-5 w-5 text-indigo-600" />
            Ownership Structure
          </CardTitle>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => navigate('/ownership-structure')}
            className="text-slate-500 hover:text-slate-700"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="animate-pulse space-y-3">
            {[1, 2, 3].map(i => (
              <div key={i} className="h-12 bg-slate-100 rounded-lg"></div>
            ))}
          </div>
        ) : (
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2 rounded-lg bg-emerald-50 border border-emerald-200">
              <div className="flex items-center gap-2">
                <Building2 className="h-4 w-4 text-emerald-600" />
                <span className="text-sm font-medium text-emerald-800">Companies</span>
              </div>
              <span className="text-lg font-bold text-emerald-600">{entities.companies}</span>
            </div>
            
            <div className="flex items-center justify-between p-2 rounded-lg bg-purple-50 border border-purple-200">
              <div className="flex items-center gap-2">
                <Users className="h-4 w-4 text-purple-600" />
                <span className="text-sm font-medium text-purple-800">Discretionary Trusts</span>
              </div>
              <span className="text-lg font-bold text-purple-600">{entities.discretionaryTrusts}</span>
            </div>
            
            <div className="flex items-center justify-between p-2 rounded-lg bg-blue-50 border border-blue-200">
              <div className="flex items-center gap-2">
                <Users className="h-4 w-4 text-blue-600" />
                <span className="text-sm font-medium text-blue-800">Unit Trusts</span>
              </div>
              <span className="text-lg font-bold text-blue-600">{entities.unitTrusts}</span>
            </div>
            
            <div className="flex items-center justify-between p-2 rounded-lg bg-amber-50 border border-amber-200">
              <div className="flex items-center gap-2">
                <Building2 className="h-4 w-4 text-amber-600" />
                <span className="text-sm font-medium text-amber-800">SMSF</span>
              </div>
              <span className="text-lg font-bold text-amber-600">{entities.smsf}</span>
            </div>
            
            <div className="flex items-center justify-between p-2 rounded-lg bg-slate-50 border border-slate-200">
              <div className="flex items-center gap-2">
                <User className="h-4 w-4 text-slate-600" />
                <span className="text-sm font-medium text-slate-800">Individuals</span>
              </div>
              <span className="text-lg font-bold text-slate-600">{entities.individuals}</span>
            </div>
            
            <Button 
              onClick={() => navigate('/ownership-structure')}
              variant="outline"
              className="w-full mt-2 text-indigo-600 border-indigo-200 hover:bg-indigo-50"
            >
              View Full Structure
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
